import {
  baseScreen,
} from 'hoc';
import React from 'react';
import {
  useHistory,
} from 'react-router';
import {
  VerificationMessage,
} from 'components';
import i18n from 'i18n-js';

const formConfirmation: React.FC = () => {
  const history = useHistory();
  return (
    <VerificationMessage
      message={i18n.t('PROMOCODE_CONFIRMATION_MESSAGE')}
      action={() => history.replace('/promo-codes')}
    />
  );
};

export const FormConfirmation = baseScreen(formConfirmation, {
  allowedRoles: ['ADMIN', 'NONE'],
});
